import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import {
  selectPersonalClientSubscriptionData,
  selectActiveTabId,
  selectAddressCurrentContractActive,
  selectConfig,
} from '../../../SubscriptionForm/SubscriptionFormSelectors'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import { updateConfig } from '../../../SubscriptionForm/SubscriptionFormSlice'

const useCreditCheck = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { country } = useSelector(selectAuthData)
  const { firstName, lastName, birthdate, civility } = useSelector(selectPersonalClientSubscriptionData)
  const contractId = useSelector(selectActiveTabId)
  const address = useSelector(selectAddressCurrentContractActive)
  const { creditCheck = {} } = useSelector(selectConfig)

  const { isLoading = false, result = null, error: rawError = null, isModalOpen = false } = creditCheck
  const errorMessage = rawError === true ? t('subscriptionForm:credit_check.error') : rawError

  const creditCheckHandler = () => {
    dispatch({
      type: subscriptionFormActionsV2.CREDIT_CHECK,
      payload: {
        contract_id: contractId,
        gender: civility,
        first_name: firstName,
        last_name: lastName,
        dob: birthdate,
        street: address?.streetName,
        street_number: address?.streetNumber,
        zip: address?.zipcode,
        city: address?.city,
      },
    })
  }

  const closeModal = () => {
    dispatch(updateConfig({ creditCheck: { ...creditCheck, isModalOpen: false } }))
  }

  const isVisible = country === 'de'
  const canRunCheck = firstName && lastName && address?.zipcode && address?.city && birthdate && civility

  return {
    t,
    isLoading,
    result,
    error: errorMessage,
    creditCheckHandler,
    isVisible,
    canRunCheck,
    isModalOpen,
    closeModal,
  }
}

export default useCreditCheck
